import { useState } from 'react'
import { Share2 } from 'lucide-react'
import { Button } from '@components/ui/button'
import { ShareModal } from '@components/ShareModal/ShareModal'

export const ShareButton = ({
  shareUrl,
  title = '',
  description = '',
  className = '',
  iconSize = 16,
  showLabel = false,
  variant = 'ghost',
  size = 'sm',
  children,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleShareClick = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <Button variant={variant} size={size} onClick={handleShareClick} className={`gap-2 ${className}`}>
        {children || (
          <>
            <Share2 size={iconSize} />
            {showLabel && <span>Share</span>}
          </>
        )}
      </Button>

      <ShareModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        shareUrl={shareUrl}
        title={title}
        description={description}
      />
    </>
  )
}
